import { analytics } from '@app/index';
import { getPageTrackingData } from '@app/utils';
import { TRACKING_EVENTS } from '@app/constants';

export const initButton = () => {
  const startTrialButtonEls = document.querySelectorAll(
    '[data-start-trial-button]'
  );

  startTrialButtonEls.forEach((button) => {
    button.addEventListener('click', () => {
      analytics.track(TRACKING_EVENTS.buttonClick, {
        ...getPageTrackingData(),
        button_name: 'Start Free Trail',
      });
    });
  });

  const coralogixMainButtonEls = document.querySelectorAll(
    '[data-coralogix-main-button]'
  );

  coralogixMainButtonEls.forEach((button) => {
    button.addEventListener('click', () => {
      analytics.track(TRACKING_EVENTS.buttonClick, {
        ...getPageTrackingData(),
        button_name: 'Coralogix.com',
      });
    });
  });

  const contactButtonEls = document.querySelectorAll('[data-contact-button]');

  contactButtonEls.forEach((button) => {
    button.addEventListener('click', () => {
      let intercomLauncherButton = document.querySelector(
        '.intercom-launcher'
      ) as HTMLElement;

      const intercomIframeEl = document.querySelector(
        '.intercom-launcher-frame'
      ) as HTMLIFrameElement;

      if (intercomIframeEl) {
        intercomLauncherButton =
          intercomIframeEl.contentWindow?.document.querySelector(
            '.intercom-launcher'
          ) || intercomLauncherButton;
      }

      if (intercomLauncherButton) {
        intercomLauncherButton.click();
      }
    });
  });
};
